//https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat

export const NumberFormat = {
    formatNumber(number, formatting = '', locale = 'pt') {
        number = Number(number);

        let lo = this.getLocale(locale);
        if (['*', ''].includes(formatting))
            return Intl.NumberFormat(lo.locale).format(number);

        //FORMAT exemplo: G/Y|C|M/2|X/2
        //S => Unsigned
        //G|{V} => Grouping: V => Y ou N
        //C|{v} => CURRENCY: V => vazio, C, N
        //D|{N} => DIGITOS MINIMOS/MAXIMOS: N => 0 a 20

        let style = {} //{ style: 'currency', currency: 'EUR', currencyDisplay: 'name', minimumFractionDigits:2, maximumFractionDigits: 2, useGrouping: false }
        let tokens = formatting.toUpperCase().split(',');
        tokens.forEach(t => {
            let st = [];
            st[0] = t[0];
            st[1] = t.substring(1);

            switch (st[0]) {
                case 'S':
                    if (number < 0)
                        number = number * -1;
                    break;
                case 'G':
                    style.useGrouping = st[1] != 'N';
                    break;
                case 'C':
                    style.style = 'currency';
                    style.currency = lo.currency;
                    switch (st[1]) {
                        case 'S': style.currencyDisplay = 'symbol'; break;
                        case 'C': style.currencyDisplay = 'code'; break;
                        case 'N': style.currencyDisplay = 'name'; break;
                        default: style.currencyDisplay = 'symbol'; break;
                    }
                    break;
                case 'D':
                    style.minimumFractionDigits = Number(st[1]);
                    style.maximumFractionDigits = Number(st[1]);
                    break;
                case 'P':
                    style.style = 'percent';
                    style.minimumFractionDigits = Number(st[1]);
                    style.maximumFractionDigits = Number(st[1]);
                    break;
                default:
                    break;
            }
        })

        return new Intl.NumberFormat(lo.locale, style).format(number);
    },
    getLocale(strLocale) {
        var defBr = {locale: 'pt-BR', currency: 'BRL'};
        switch (strLocale) {
            case 'pt':
                return defBr;
            case 'en':
                return {locale: 'en-US', currency: 'USD'};
            case 'py':
            case 'gn':
                return {locale: 'gn-PY', currency: 'PYG'};
            default:
                return defBr;
        }
    },
    locales() {
        return [
            { description: 'brasil', locale: 'pt' },
            { description: 'eua', locale: 'en' },
            { description: 'paraguai', locale: 'gn' },
            //{ description: 'locale-alemao', locale: 'de' }
        ]
    },
    commonFormats(locale = 'pt') {
        
        let numero = -123456.789;
        let _this = this;
        function getFormatting(formatting, type = 'number', number = numero) {
            return { formatting, example: _this.formatNumber(number, formatting, locale), type}
        }
        return [
            getFormatting('*'),
            getFormatting('D2'),
            getFormatting('D0'),
            getFormatting('S,D2'),
            getFormatting('D3'),
            getFormatting('S,D3'),
            getFormatting('P'),
            getFormatting('GN,D2'),
            getFormatting('S,GN,D2'),
            getFormatting('GN,D3'),
            getFormatting('S,GN,D3'),
            getFormatting('C,D2', 'currency', 23456.789),
            getFormatting('C,D3', 'currency', 23456.789),
            getFormatting('CN,D0', 'currency', 23456.789),
            getFormatting('CN,D2', 'currency', 23456.789),
            getFormatting('CN,D3', 'currency', 23456.789),
            getFormatting('CC,D0', 'currency', 23456.789),
            getFormatting('CC,D2', 'currency', 23456.789),
            getFormatting('CC,D3', 'currency', 23456.789) 
        ]
    },
}